<button *ngIf="remainingTimeString; else loader" class="btn btn-outline-secondary" type="button"
        title="Sie werden automatisch abgemeldet {{remainingTimeString}}" style="opacity: 1" (click)="extend()">
    <img src="assets/icons/clock.svg" alt="Symbol-Uhr" width="16" height="16" style="margin-bottom: 4px">
    {{remainingTimeString}}
</button>
<ng-template #loader>
    <button class="btn btn-outline-secondary" type="button" style="opacity: 1">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <span class="sr-only">Loading...</span>
        {{updating ? 'Wird erneuert...' : 'aktualisiere...'}}
    </button>
</ng-template>
